import { GOOGLE_SEARCH_BOT, YANDEX_SEARCH_BOT } from '../../constants/userAgent';

export function checkSearchBot(userAgent: string) {
  return YANDEX_SEARCH_BOT.test(userAgent) || GOOGLE_SEARCH_BOT.test(userAgent);
}
